module.exports = __webpack_public_path__ + "img/maze_rectangular_c.d68976ba.svg";